class Ref {
  constructor({ num, gen }) {
    this.num = num;
    this.gen = gen;
  }

  toString() {
    let str = `${this.num}R`;
    if (this.gen !== 0) {
      str += this.gen;
    }
    return str;
  }
}

const getRawDestination = async (dest, pdf) => {
  if (typeof dest === 'string') {
    return pdf.getDestination(dest);
  }
  return dest;
};

const resolveOutlineItem = async (item, pdf, level) => {
  try {
    if (!item.dest) {
      return null;
    }

    const destination = await getRawDestination(item.dest, pdf);

    if (!destination) {
      return null;
    }

    const [ref] = destination;
    const pageIndex = await pdf.getPageIndex(new Ref(ref));

    return {
      pageNumber: pageIndex + 1,
      title: item.title ? item.title.trim() : "Untitled",
      level: level,
    };
  } catch (error) {
    console.warn(`Could not resolve page for item "${item.title}"`, error);
    return null;
  }
};


const collectItemPromises = (items, pdf, accumulatedPromises = [], level = 0) => {
  if (!items || !Array.isArray(items)) return accumulatedPromises;

  for (const item of items) {
    if (item.dest) {
      accumulatedPromises.push(resolveOutlineItem(item, pdf, level));
    }
    if (item.items && item.items.length > 0) {
      collectItemPromises(item.items, pdf, accumulatedPromises, level + 1);
    }
  }

  return accumulatedPromises;
};

export const getTOCItems = async (pdf) => {
  const outline = await pdf.getOutline();
  if (!outline) {
    return [];
  }

  const promises = collectItemPromises(outline, pdf, [], 0);
  const results = await Promise.all(promises);
  const validItems = results.filter((item) => item !== null);

  const uniqueItems = [];
  const seen = new Set();
  for (const item of validItems) {
    const key = `${item.pageNumber}-${item.title}`;
    if (!seen.has(key)) {
      seen.add(key);
      uniqueItems.push(item);
    }
  }

  return uniqueItems;
};
